export default __webpack_public_path__ + "static/media/competences.2d709986.svg";